import { hot } from 'react-hot-loader'
import React from 'react'
import ClassementReferencement from '../components/ClassementReferencement/ClassementReferencement'

function App() {
  return <ClassementReferencement />
}

export default hot(module)(App)
